module.exports = __webpack_public_path__ + "static/media/np-showups.3aa4d488.svg";